export const environment = {
  NAME: 'development',
  AGTRACE_API: 'https://api-agtrace-development.agridence.com/api/',
  ARP_API: 'https://api-platform-testing.agridence.com/api/v1/',
  POSTHOG: {
    KEY: 'phc_NMIi98nvCxMFry1oys6hGDagws4j623XorKRHjAHSXp',
    HOST: 'https://us.i.posthog.com'
  },
  SENTRY: {
    DSN: 'https://527bd596ce63b0c086dca0d107b492ed@o4510859648892928.ingest.de.sentry.io/4510938735116368',
    DEBUG: false
  }
} as const;
